/**
 * A workspace's uploads, asked for again every two seconds while one of them is importing, so the list follows the
 * import without the person doing anything.
 */
import { useQuery } from '@tanstack/react-query';
import { uploadService } from '@/services/upload.service';
import { UPLOAD_STATUS_REFRESH_MS, uploadsKey } from '@/config/upload';
import { hasImportInProgress } from '@/utils/upload';

export function useUploads(workspace: string, enabled = true) {
  return useQuery({
    queryKey: uploadsKey(workspace),
    queryFn: () => uploadService.list(workspace),
    enabled,
    retry: false,
    refetchInterval: (query) => (hasImportInProgress(query.state.data) ? UPLOAD_STATUS_REFRESH_MS : false),
  });
}
